import { GenericBackendResponse } from '../genericBackendResponse';

/** Un mes de la serie del valor de un plan. */
export interface PlanValuePointI {
	/** El mes que cierra el punto, `AAAA-MM`. */
	month: string;
	/**
	 * Día (`AAAA-MM-DD`) al que está valorado el punto (product#75): el último día del mes si es un
	 * mes cerrado y valorado al cierre; si no (el mes en curso, o un mes cerrado cuyo precio de cierre
	 * aún no está), la fecha del valor liquidativo de la foto. Hasta ese día se cuenta lo que entró.
	 */
	date: string;
	/** 🔴 Derechos consolidados del plan ese mes, en CÉNTIMOS. */
	vestedRightsCents: number;
}

/** La serie mensual del valor de UN plan del usuario. */
export interface PlanValueHistoryI {
	/** El `id` del plan en `GET /users/plans`. */
	userEppConfigId: string;
	/**
	 * Un punto por mes, ordenados. 🔴 Un mes sin foto NO tiene punto: es un hueco, nunca 0. Un plan
	 * sin productos atribuibles viaja con la lista vacía.
	 */
	points: PlanValuePointI[];
}

/**
 * `GET /users/plans/value-history` (comparsa#848) — el valor de cada plan del usuario del token,
 * mes a mes, de la foto diaria que la sync lee de Caser: lo que tiene ESA persona en su plan, no
 * el valor liquidativo del fondo. Para la gráfica de evolución del Resumen multicuenta.
 *
 * Una respuesta de error (un 404 con un comparsa anterior al endpoint) lanza: quien llama lo
 * pinta como «sin dato».
 */
const getPlansValueHistory = async (
	token: string
): Promise<GenericBackendResponse<PlanValueHistoryI[]>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/plans/value-history`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		throw new Error(`GET /users/plans/value-history respondió ${response.status}`);
	}

	return response.json();
};

export default getPlansValueHistory;
